
      import Vue from 'vue';
      export default {
        scrollToTop: true,
        head() {
          return {
            title: this.title,
            meta: [{
                hid: 'og:title',
                property: 'og:title',
                content: this.title
              },
              {
                hid: 'twitter:title',
                property: 'twitter:title',
                content: this.title
              },
              {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Aarti "Jai Devi Jai Shante Janani" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Jai Devi Jai Shante Janani" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Jai Devi Jai Shante Janani, Devi Aarti, Shanta devi Aarti, Jai Shante Janani Aarti, Jai Devi Aarti, Shanta Durgechi Aarti'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Jai Devi Jai Shante Janani, Devi Aarti, Shanta devi Aarti, Goddess Aarti, Jai Devi Aarti lyrics, Jai Shante Janani Aarti, Goddess Durga Aarti, Shanti Mata Aarti, Devi Bhajan, Shakti worship, Jai Devi Aarti, Devotional aarti, Aarti lyrics in Hindi, Jai Devi Jai Shanti Aarti, jai devi jai shanti janani lyrics, jai devi jai shanti janani lyrics in english, jai devi jai shanti janani lyrics in marathi'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/shantadurga.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/shantadurga.webp'
          },
            ],
          }
        },
      
          components: {
       },
       data() {
         return {
           title:'Jai Devi Jai Shante Janani | Shanta Durgechi Aarti - जय देवी जय शांते जननी (शांतादुर्गेची आरती)',
           langauageMarathi: true
         }
       },
       layout: 'detailsPage-withoutFooter',
   
   
       jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/shantadurga"
        },
        "headline": "Jai Devi Jai Shante Janani - जय देवी जय शांते जननी (शांतादुर्गेची आरती)",
        "name" : "Jai Devi Jai Shante Janani - Shanta Durgechi Aarti",
        "description": "Explore the full lyrics of Aarti 'Jai Devi Jai Shante Janani' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/shantadurga.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },

       computed: {
   
       },
       methods:{
       changeLanguage:function () {
         this.langauageMarathi = !this.langauageMarathi
       }
     }
   
     }

   